import { ComponentProps, FC } from 'react'
import * as Dropzone from 'react-dropzone'
import { styled } from '../../../config'
import { Close, FileCheck, FileCross } from '../../../icons'
import { IconButton } from '../../IconButton'
import { Spacer } from '../../Spacer'
import { Text } from '../../Text'
import { OnRemove } from '../types'

export interface Props {
  file: Dropzone.FileWithPath
  title: string
  index: number
  status?: 'success' | 'error'
  isDisabled?: boolean
  onRemove: OnRemove
}

const Root = styled('div', {
  display: 'flex',
  backgroundColor: '$whiteA200',
  borderRadius: '$12',
  padding: '6px 8px 6px 14px',
  alignItems: 'center',
  gap: '12px',
  variants: {
    variant: {
      default: {},
      ai: { borderRadius: '$4' }
    }
  }
})

const StyledText = styled(Text, {
  color: 'white',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

const StyledFileCheck = styled(FileCheck, {
  color: '$green0600',
  minWidth: '16px'
})

const StyledFileCross = styled(FileCross, {
  color: '$red0600',
  minWidth: '16px'
})

export const FileItem: FC<Props & ComponentProps<typeof Root>> = ({
  file,
  index,
  title,
  status = 'success',
  isDisabled,
  onRemove,
  ...rest
}) => {
  return (
    <Root {...rest}>
      {status === 'success' ? <StyledFileCheck /> : <StyledFileCross />}
      <StyledText size="14" title={title}>
        {title}
      </StyledText>
      <Spacer />
      <IconButton
        variant="ghostInverted"
        icon={<Close />}
        onClick={() => onRemove(file, index)}
        disabled={isDisabled}
      />
    </Root>
  )
}
